__turbopack_context__.v({
  "actionsNav": "CarouselControllersTop-module-scss-module__AFQSTG__actionsNav",
  "carouseDots": "CarouselControllersTop-module-scss-module__AFQSTG__carouseDots",
  "carouseDotsItem": "CarouselControllersTop-module-scss-module__AFQSTG__carouseDotsItem",
  "carouseDotsItemActive": "CarouselControllersTop-module-scss-module__AFQSTG__carouseDotsItemActive",
  "headActions": "CarouselControllersTop-module-scss-module__AFQSTG__headActions",
  "navItem": "CarouselControllersTop-module-scss-module__AFQSTG__navItem",
});
